import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import {
  ORIGIN_PARAM,
  ORIGIN_PARAM_VALUES,
} from '@xing-com/crate-jobs-constants';
import { ROUTES } from '@xing-com/crate-jobs-paths';
import { IconArrowLeft } from '@xing-com/icons';
import { mediaTopBarVisible } from '@xing-com/layout-tokens';

export const BackButton: React.FC = () => {
  const { isLoggedIn } = useLoginState();
  const { getSearchParameter } = useSearchParameter();
  const fromSearchAlerts =
    getSearchParameter(ORIGIN_PARAM) === ORIGIN_PARAM_VALUES.searchAlerts;

  const startpage = isLoggedIn ? ROUTES.findJobs : '/';

  if (fromSearchAlerts) {
    return (
      <Button to={ROUTES.myJobsSearchAlerts} icon={IconArrowLeft}>
        <FormattedMessage id="JOBS_MYJOBS_SEARCH_ALERTS_SECTION_TITLE" />
      </Button>
    );
  }

  return (
    <Button to={startpage} icon={IconArrowLeft}>
      <FormattedMessage id="JOBS_SEARCH_BUTTON_BACK" />
    </Button>
  );
};

const Button = styled(TextButton)`
  justify-content: start;

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;
